import {
  setUserData,
  setWalletAddressValue,
} from "../Components/Redux/actions";
import { store } from "../Components/Redux/store";
import { disconnectWallet } from "../Components/wallet/metamask";
import { api_url, blog_api_url, plugin_url, focii_url } from "../config";
import apiClient from "./axiosInterceptor";

const registerUser = async (data) => {
  return apiClient.post(api_url + "auth/v2/registry", data).then((res) => res);
};

const resendEmail = async (data) => {
  return apiClient
    .post(api_url + `auth/v2/resend/password`, data)
    .then((res) => res);
};

const verifyLink = async (data) => {
  return apiClient
    .get(api_url + `auth/v2/verify/link`, { params: data })
    .then((res) => res);
};

const loginUser = async (credentials) => {
  return apiClient
    .post(api_url + `auth/v2/login`, credentials)
    .then((res) => res);
};

const logoutUser = async () => {
  return apiClient.post(api_url + `auth/v2/logout`).then((res) => res);
};

const socialLogin = (params) => {
  let redirect = api_url + `auth/v2/google${params}`;
  window.location.href = redirect;
};

const setPassword = async (data) => {
  return apiClient
    .post(api_url + `auth/v2/change/password`, data)
    .then((res) => res);
};

const setPasswordBoolean = async () => {
  return apiClient
    .patch(api_url + `auth/v2/password/boolean`)
    .then((res) => res);
};

const resetPasswordRequest = async (data) => {
  return apiClient
    .post(api_url + `auth/v2/forgot/password`, data)
    .then((res) => res);
};

const verifyResetPassword = async (data) => {
  return apiClient
    .get(api_url + `auth/v2/verify/link/${data}`)
    .then((res) => res);
};


const changePassword = async (data) => {
  return apiClient
    .post(api_url + `auth/v2/set/forgot/password`, data)
    .then((res) => res);
};
const signUpPassword = async (data) => {
  return apiClient
    .post(api_url + `auth/v2/set/signup/password`, data)
    .then((res) => res);
};


const visitCount = async () => {
  return apiClient.post(api_url + `users/v2/add/visit`).then((res) => res);
};

const addWalletApi = async (data) => {
  return apiClient
    .post(api_url + `crypto/wallet/v1/add/chain/wallet`, data)
    .then((res) => res);
};

const getAllBlogs = async () => {
  return apiClient.get(blog_api_url + `getallBlogs`).then((res) => res);
};
const getDynamicBlog = async (title) => {
  return apiClient.get(blog_api_url + `blog/` + title).then((res) => res);
};

const getAllWatchedVideos = async () => {
  return apiClient
    .get(plugin_url + `/plugin/api/video/userWatchHistory`)
    .then((res) => res);
};
const getVideoAnalytics = async (id) => {
  return apiClient
    .get(plugin_url + `/plugin/api/video/userAnalytics/${id}`)
    .then((res) => res);
};

const removeLocalStorage = () => {
  let visit = getVisit();
  localStorage.clear();
  localStorage.setItem("visited", visit);
  store.dispatch(setUserData(null));
  store.dispatch(setWalletAddressValue(null));
};

const setVisit = () => {
  localStorage.setItem("visited", true);
};

const getVisit = () => {
  return JSON.parse(localStorage.getItem("visited"));
};

const startCalibrationProcess = () => {
  return apiClient
    .post(focii_url + `/development/plugin/api/calibration/startCalibration`)
    .then((res) => res);
};

const checkUserCalibrationStatus = () => {
  return apiClient 
    .get(focii_url + `/development/plugin/api/calibration/calibrationStatus`)
    .then((res) => res);
}

const sendCalibrationData = async (id, data) => {
    return apiClient
      .post(focii_url + `/development/plugin/api/calibration/addData/${id}`,data)
      .then((res) => res);
}


const userService = {
  registerUser,
  resendEmail,
  verifyLink,
  loginUser,
  setPassword,
  setPasswordBoolean,
  socialLogin,
  resetPasswordRequest,
  verifyResetPassword,
  changePassword,
  signUpPassword,
  logoutUser,
  visitCount,
  removeLocalStorage,
  setVisit,
  getVisit,
  addWalletApi,
  getAllBlogs,
  getDynamicBlog,
  getAllWatchedVideos,
  getVideoAnalytics,
  startCalibrationProcess,
  checkUserCalibrationStatus,
  sendCalibrationData
};
export default userService;
